import React from 'react';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
import FapiaoStatusHint from './FapiaoStatusHint';
var FapiaoStatus = function FapiaoStatus(_ref) {
  var _fapiao$status;
  var fapiao = _ref.fapiao,
    fapiaoCreationUrl = _ref.fapiaoCreationUrl;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var fapiaoStatusTerm = "fapiao-status-".concat((_fapiao$status = fapiao === null || fapiao === void 0 ? void 0 : fapiao.status) !== null && _fapiao$status !== void 0 ? _fapiao$status : '');
  if ((fapiao === null || fapiao === void 0 ? void 0 : fapiao.status) === 'completed' && fapiao !== null && fapiao !== void 0 && fapiao.downloadUrl) {
    return /*#__PURE__*/React.createElement("a", {
      href: fapiao.downloadUrl,
      target: "_blank",
      rel: "noreferrer",
      "aria-label": t(fapiaoStatusTerm)
    }, /*#__PURE__*/React.createElement(T, {
      source: fapiaoStatusTerm,
      params: {
        number: fapiao.number
      }
    }), /*#__PURE__*/React.createElement(FapiaoStatusHint, {
      hintTerm: "fapiao-hint-".concat(fapiao.status, "-").concat(fapiao.type)
    }));
  }
  var showNonDownloadFallback = false;
  if (showNonDownloadFallback && (fapiao === null || fapiao === void 0 ? void 0 : fapiao.status) === 'can-generate') {
    return /*#__PURE__*/React.createElement(Link, {
      className: "fw-bold",
      to: fapiaoCreationUrl,
      role: "button"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.generate-fapiao"
    }));
  }
  if (showNonDownloadFallback && fapiao) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
      source: fapiaoStatusTerm,
      params: {
        number: fapiao.number
      }
    }), /*#__PURE__*/React.createElement(FapiaoStatusHint, {
      hintTerm: "fapiao-hint-".concat(fapiao.status, "-").concat(fapiao.type),
      alternateHintTerm: "fapiao-hint-".concat(fapiao.status)
    }));
  }
  if (showNonDownloadFallback) {
    return /*#__PURE__*/React.createElement(Link, {
      className: "fw-bold",
      to: fapiaoCreationUrl,
      role: "button"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.generate-fapiao"
    }));
  }
  return null;
};
export default FapiaoStatus;